export const AUDIT_REDACTED_VALUE = "[Redacted]";
export const AUDIT_NEVER_LOGGED_KEYS = [
    "api_key",
    "attachment",
    "attachment_bytes",
    "authorization",
    "base64",
    "body",
    "bytes",
    "card_number",
    "content",
    "cookie",
    "customer_contact",
    "customer_name",
    "cvc",
    "cvv",
    "data",
    "description",
    "detail",
    "device_token",
    "display_name",
    "email",
    "id_token",
    "legal_name",
    "manager_note",
    "medical_note",
    "new_password",
    "new_values",
    "note",
    "pan",
    "password",
    "payload",
    "phone",
    "previous_values",
    "push_token",
    "raw_body",
    "reason",
    "refresh_token",
    "response",
    "secret",
    "skipped_note",
    "staff_response",
    "suggested_action",
    "symptoms",
    "token",
    "trading_name",
    "value",
    "values",
    "voided_reason",
];
const forbiddenKeys = new Set(AUDIT_NEVER_LOGGED_KEYS);
function normalizedKey(key) {
    return key
        .trim()
        .toLowerCase()
        .replaceAll(/[^a-z0-9]+/g, "_");
}
function sanitizeValue(value) {
    if (Array.isArray(value)) {
        return value.map(sanitizeValue);
    }
    if (value !== null && typeof value === "object") {
        return sanitizeAuditSummary(value);
    }
    return value;
}
export function sanitizeAuditSummary(summary) {
    return Object.fromEntries(Object.entries(summary).map(([key, value]) => [
        key,
        forbiddenKeys.has(normalizedKey(key))
            ? AUDIT_REDACTED_VALUE
            : value === undefined
                ? null
                : sanitizeValue(value),
    ]));
}
